"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const user_serializer_1 = require("../serializers/user.serializer");
const license_serializer_1 = require("../serializers/license.serializer");
const sdk_constants_1 = require("../constants/sdk.constants");
const profile_client_1 = require("./profile.client");
class LicenseClient {
    static newInstance(options, retryOptions) {
        return new LicenseClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new license_serializer_1.LicenseSerializer(), new user_serializer_1.UserSerializer(), profile_client_1.ProfileClient.newInstance(options, retryOptions));
    }
    constructor(client, serializer, userSerializer, profileClient) {
        this.client = client;
        this.serializer = serializer;
        this.userSerializer = userSerializer;
        this.profileClient = profileClient;
    }
    findCurrent(headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/licenses`, {
                headers,
            });
            const { profile, licenses } = response.body;
            return {
                user: profile ? this.userSerializer.serializeOne(profile) : undefined,
                licenses: licenses
                    ? licenses.map((license) => this.serializer.serializeOne(license))
                    : [],
            };
        });
    }
    findCurrentV2(headers_1) {
        return __awaiter(this, arguments, void 0, function* (headers, skip = 0, limit = 10) {
            const profile = yield this.profileClient.findCurrent(headers);
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_LICENSE_API_PREFIX}/v2/licenses`, {
                headers,
                params: {
                    skip,
                    limit,
                },
            });
            const licenses = response.body.data;
            return {
                user: profile,
                licenses: licenses
                    ? licenses.map((license) => this.serializer.serializeOne(license))
                    : [],
            };
        });
    }
    findCurrentV3(headers_1) {
        return __awaiter(this, arguments, void 0, function* (headers, skip = 0, limit = 10) {
            const profile = yield this.profileClient.findCurrent(headers);
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_LICENSE_API_PREFIX}/v3/licenses`, {
                headers,
                params: {
                    skip,
                    limit,
                },
            });
            const licenses = response.body.data;
            return {
                user: profile,
                licenses: licenses
                    ? licenses.map((license) => this.serializer.serializeOne(license))
                    : [],
            };
        });
    }
    findCurrentLicense(headers_1) {
        return __awaiter(this, arguments, void 0, function* (headers, skip = 0, limit = 10) {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_LICENSE_API_PREFIX}/v2/licenses`, {
                headers,
                params: {
                    skip,
                    limit,
                },
            });
            const licenses = response.body.data;
            return licenses
                ? licenses.map((license) => this.serializer.serializeOne(license))
                : [];
        });
    }
    findCurrentLicenseV3(headers_1) {
        return __awaiter(this, arguments, void 0, function* (headers, skip = 0, limit = 10) {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_LICENSE_API_PREFIX}/v3/licenses`, {
                headers,
                params: {
                    skip,
                    limit,
                },
            });
            const licenses = response.body.data;
            return licenses
                ? licenses.map((license) => this.serializer.serializeOne(license))
                : [];
        });
    }
}
exports.LicenseClient = LicenseClient;
//# sourceMappingURL=license.client.js.map